import React from "react";
import {
  Button,
  ButtonGroup, Content, Dialog, DialogContainer, Flex, Heading, TextField, View
} from "@adobe/react-spectrum";

class CloneProfileModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      newName: '',
      isSaving: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      this.setState({
        isOpen: this.props.isOpen,
        newName: this.props.sourceProfile ? `${this.props.sourceProfile.name} (${this.props.translate('smart_flag_profile_copy')})` : '',
        isSaving: false,
      });
    }
  }

  onOpenChange = (isOpen) => {
    this.setState({
      isOpen,
      newName: '',
      isSaving: false,
    });
    if (!isOpen) {
      const { onClose } = this.props;
      if (onClose) {
        onClose();
      }
    }
  };

  handleNameChange(value) {
    this.setState({ newName: value });
  }

  handleClone = () => {
    const { newName, isSaving } = this.state;
    const { sourceProfile, onConfirm } = this.props;

    if (isSaving || !newName || !sourceProfile) return;

    this.setState({ isSaving: true });

    if (onConfirm) {
      onConfirm(sourceProfile.id, newName)
        .then(() => {
          this.setState({ isSaving: false });
          this.onOpenChange(false);
        })
        .catch(() => {
          this.setState({ isSaving: false });
        });
    }
  };

  render() {
    const { sourceProfile, translate } = this.props;
    const { isOpen, newName, isSaving } = this.state;

    if (!sourceProfile) {
      return null;
    }

    return (
      <DialogContainer isDismissable={false} onDismiss={() => this.onOpenChange(false)}>
        {isOpen && (
          <Dialog>
            <Heading>{translate('smart_flag_clone_profile')}</Heading>
            <Content>
              <TextField
                label={translate('smart_flag_new_profile_name')}
                value={newName}
                onChange={(v) => this.handleNameChange(v)}
                isRequired
                autoFocus
                marginTop="size-200"
                width="size-5000"
              />
            </Content>
            <ButtonGroup>
              <Button
                variant="secondary"
                onPress={() => this.onOpenChange(false)}
                isDisabled={isSaving}
              >
                {translate('general_cancel')}
              </Button>
              <Button
                variant="accent"
                onPress={() => this.handleClone()}
                isDisabled={!newName || isSaving}
              >
                {isSaving ? translate('smart_flag_cloning') : translate('smart_flag_clone')}
              </Button>
            </ButtonGroup>
          </Dialog>
        )}
      </DialogContainer>
    );
  }
}

export default CloneProfileModal;
